"use strict";

var _OverdriveProvider;
import { OverdriveProvider } from '@autoguru/overdrive';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { AsyncBoundary } from '@autoguru/suspense';
import { HomeComponent } from '~/src/scenes/Homepage';
import { jsx as _jsx } from "react/jsx-runtime";
const relayModernEnvironment = createEnvironment();
export const App = () => _OverdriveProvider || (_OverdriveProvider = /*#__PURE__*/_jsx(OverdriveProvider, {
  children: /*#__PURE__*/_jsx(EnvironmentProvider, {
    environment: relayModernEnvironment,
    children: /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: null,
      children: /*#__PURE__*/_jsx(HomeComponent, {})
    })
  })
}));